import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import PaymentRequestFrame from '../../containers/Payment';

class PaymentPopup extends React.PureComponent {
  static propTypes = {
    paymentRequest: PropTypes.object,
    removePaymentRequest: PropTypes.func.isRequired,
    setPaymentResponse: PropTypes.func.isRequired,
  };

  onPaymentComplete = (data) => {
    if (data) {
      this.props.setPaymentResponse({ response: data });
    }
    this.props.removePaymentRequest();
  };

  isVisible = () => (
    !isEmpty(this.props.paymentRequest)
  );

  render() {
    const {
      paymentRequest,
    } = this.props;

    const visible = this.isVisible();

    if (!visible) {
      return null;
    }
    return (
      <PaymentRequestFrame paymentRequest={paymentRequest} onPaymentComplete={this.onPaymentComplete} />
    );
  }
}

export default PaymentPopup;



// WEBPACK FOOTER //
// ./src/app/components/PaymentPopup/index.js